module.exports = __webpack_public_path__ + "static/media/TrayLower.b20121ac.svg";